/* ==========================================================================
   NHD - Evergreen lane - The Truth About Cholesterol - VSL WATCH PAGE
   Theme asset. Every query is scoped to #nhdChevVsl.

   What this file does beyond Paul's presentation layer:

   1. Click-to-load YouTube facade on the training player. Shopify caps
      hosted video at 10 minutes, so a 60-minute training can never be
      Shopify hosted at any file size. Unlisted YouTube it is.

   2. Stamps UTMs onto every /cart/add form as hidden line item
      properties, so attribution survives into the Shopify order. Both
      pages are on shop.naturalheartdoctor.com now, so nothing crosses a
      domain boundary anywhere in the purchase path.

   3. Reads the opt-in stamp the landing page left in sessionStorage. A
      visitor who reached this URL without opting in gets a neutral line
      instead of "You're in", which would otherwise read as broken.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.getElementById('nhdChevVsl');
  if (!root) return;

  var YT = (root.dataset.yt || '').trim();
  var YT_ID = /^[A-Za-z0-9_-]{11}$/;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  root.classList.add('js-ecg');

  /* Full-bleed fallback for browsers without :has(). The stylesheet does
     the real work; this covers the rest. */
  var section = root.closest('.shopify-section');
  if (section) section.classList.add('nhd-chev-fullbleed');

  /* ---------------------------------------------------------------- UTMs */
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content',
                  'utm_term', 'gclid', 'fbclid', '_ef_transaction_id'];
  var q = new URLSearchParams(window.location.search);

  function store(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return sessionStorage.getItem(k) || ''; } catch (e) { return ''; } }

  UTM_KEYS.forEach(function (k) {
    var v = q.get(k);
    if (v) store('nhd_chev_' + k, v);
  });

  function utm(k) { return q.get(k) || read('nhd_chev_' + k) || ''; }

  /* ------------------------------------------------- masterclass buy forms

     Fill the hidden properties. utm_content is pre-seeded in Liquid with
     the placement, so a real utm_content from the URL wins and the
     placement is the fallback.

     QUANTITY IS CLAMPED TO ONE. A plain POST to /cart/add increments, so
     add-to-cart, back button, add-to-cart again put two copies of a
     recorded masterclass in the cart and charged $94. Nobody needs two,
     and the refund request is guaranteed.

     So the submit is intercepted: read the cart, and if the masterclass is
     already in it, force that line to quantity 1 and collapse any
     duplicates left over from earlier clicks, rather than adding again.
     The first line wins, which keeps the placement that actually earned
     the click.

     If any of this fails the form is submitted natively, so the button
     never dead-ends on a network hiccup. */
  var CART_JSON = { 'Content-Type': 'application/json' };

  function clampAndCheckout(form) {
    var variantId = String(form.querySelector('[name="id"]').value);

    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var mine = (cart.items || []).filter(function (i) {
          return String(i.variant_id) === variantId;
        });

        if (!mine.length) {
          return fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
        }

        /* Keep the first line at 1, zero out any duplicates. Zeroing
           shifts the remaining line keys, so this runs in sequence rather
           than in parallel. */
        var steps = mine.map(function (item, idx) {
          return function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: CART_JSON,
              body: JSON.stringify({ id: item.key, quantity: idx === 0 ? 1 : 0 })
            });
          };
        });

        return steps.reduce(function (chain, step) {
          return chain.then(step);
        }, Promise.resolve());
      })
      .then(function () {
        window.location.href = '/checkout';
      });
  }

  /* The buy forms have NO action attribute and a type="button" button.
     2026-09-25: the theme's own add-to-cart script (global-*.js) listens
     for submits on any form whose action is /cart/add and adds the item
     itself, alongside this file. That bypassed the quantity clamp and put
     extra masterclass lines in the cart. With no action and no submit
     event, nothing but this file ever acts on these forms. The real
     endpoint sits in data-cart-add and is only set for the fallback. */
  function nativePost(form) {
    form.setAttribute('action', form.getAttribute('data-cart-add') || '/cart/add');
    HTMLFormElement.prototype.submit.call(form);   /* fires no submit event */
  }

  root.querySelectorAll('.mc-buy').forEach(function (form) {
    form.querySelectorAll('input[data-utm]').forEach(function (input) {
      var v = utm(input.dataset.utm);
      if (v) input.value = v;
    });

    function buy(ev) {
      if (ev) { ev.preventDefault(); ev.stopPropagation(); }
      if (form.classList.contains('is-sending')) return;
      if (!window.fetch || !window.Promise) { nativePost(form); return; }

      form.classList.add('is-sending');

      clampAndCheckout(form).catch(function () {
        /* Something went wrong reading or changing the cart. Fall back to
           the plain form post rather than stranding the visitor. */
        form.classList.remove('is-sending');
        nativePost(form);
      });
    }

    var btn = form.querySelector('button');
    if (btn) btn.addEventListener('click', buy);
    form.addEventListener('submit', buy);   /* belt and braces */
  });

  /* --------------------------------------------------------- ECG rule */
  var RULE =
    '<svg viewBox="0 0 124 22" aria-hidden="true" focusable="false">' +
      '<circle class="halo" cx="6" cy="11" r="9"/>' +
      '<circle class="node" cx="6" cy="11" r="4.6"/>' +
      '<path class="base" d="M13,11 H56 l3,-1 l3,1 l4,-9 l5,17 l5,-12 l3,4 h7 H120"/>' +
      '<path class="scan" d="M13,11 H56 l3,-1 l3,1 l4,-9 l5,17 l5,-12 l3,4 h7 H120"/>' +
    '</svg>';

  root.querySelectorAll('.sec-head h2, .mc-sub-head h2, .final h2').forEach(function (h) {
    var span = document.createElement('span');
    span.className = 'ecg-rule';
    span.setAttribute('aria-hidden', 'true');
    span.innerHTML = RULE;
    h.insertAdjacentElement('afterend', span);
  });

  /* ---------------------------------------------------- smooth anchors */
  root.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (ev) {
      var id = a.getAttribute('href').slice(1);
      if (!id) return;
      var target = root.querySelector('#' + CSS.escape(id));
      if (!target) return;
      ev.preventDefault();
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  });

  /* ------------------------------------------------------- opt-in gate */
  var strip = root.querySelector('.confirm-strip');
  if (strip) {
    var lead = null;
    try { lead = JSON.parse(read('nhd_chev_lead') || 'null'); } catch (e) { lead = null; }
    var cameThroughOptIn = !!(lead && lead.at) || q.get('access') === '1';

    if (cameThroughOptIn) {
      if (lead && lead.fname) {
        var b = strip.querySelector('summary b');
        if (b) b.textContent = '✓ You’re in, ' + lead.fname + '.';
      }
    } else {
      /* No opt-in stamp. Do not tell this person they are "in". */
      strip.setAttribute('data-gate', 'cold');
      var sum = strip.querySelector('summary');
      if (sum) {
        sum.innerHTML = '<b>Your training is below.</b> ' +
          '<span class="confirm-toggle">Want the access link emailed to you?</span>';
      }
      var p = strip.querySelector('p');
      if (p) {
        p.innerHTML = 'Register on the training page and we will email you a private ' +
          'access link so you can return anytime. <b>Gmail users:</b> our email often ' +
          'lands in the <b>Promotions tab</b>. Add <b>health@naturalheartdoctor.com</b> ' +
          'to your contacts so you never miss it.';
      }
    }
  }

  /* -------------------------------------------------- pulse ring + player */
  var player = root.querySelector('.player');
  var playBtn = root.querySelector('.player .play');

  if (playBtn && !reduce) {
    var ring = document.createElement('span');
    ring.className = 'pulse-ring';
    playBtn.insertBefore(ring, playBtn.firstChild);
  }

  if (player) {
    if (YT_ID.test(YT)) {
      player.setAttribute('data-yt', YT);
      player.setAttribute('role', 'button');
      player.setAttribute('tabindex', '0');

      var start = function () {
        if (player.classList.contains('is-playing')) return;
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + YT +
                '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
        f.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; picture-in-picture; fullscreen');
        f.setAttribute('allowfullscreen', '');
        f.setAttribute('title', 'The Truth About Cholesterol, full training');
        player.appendChild(f);
        player.classList.add('is-playing');
        player.removeAttribute('tabindex');
      };

      player.addEventListener('click', start);
      player.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); start(); }
      });
    } else {
      /* No id wired: keep the poster, drop the play affordance, stay out
         of the tab order. The page ships without ever showing a broken
         player. */
      player.classList.add('no-video');
    }
  }

  /* --------------------------------------------------- scroll reveal */
  var SEL = '.sec-head,.mc-sub-head,.take,.test,.inc-card,.module,.fence-card,' +
            '.next-card,.mc-card,.mc-copy,.oli-visual,.oli-visual-img,.oli-copy,' +
            '.faq details,.story .box,.fence .big-line,.covers,.mc-includes,.test-fine';
  var items = root.querySelectorAll(SEL);
  items.forEach(function (el) { el.classList.add('rv'); });

  if (reduce || !('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    items.forEach(function (el, i) {
      el.style.transitionDelay = (Math.min(i % 4, 3) * 70) + 'ms';
      io.observe(el);
    });
  }

  /* --------------------------------------------------- lazy offscreen */
  root.querySelectorAll('img').forEach(function (img, i) {
    img.setAttribute('decoding', 'async');
    if (i > 0 && !img.closest('header')) img.setAttribute('loading', 'lazy');
  });
})();